/**
 * @description 本地router-base值为 '/'，但是生产环境因为项目路径的影响会有 `/auth`
 * @param [string] path 
 * @returns newPath
 */
export const getBasePath = (path: string) => {
  return process.env.NEXT_PUBLIC_APP_ENV?.toLocaleLowerCase() !== 'local' ? `/auth${path}` : path
}